import { animated, useTrail } from "react-spring";
import { useRecoilValue } from "recoil";
import { getCurrentContent, getCurrentProblem } from "selectors/controller";
import { appStrings } from "utils/appStrings";
import { toPersian } from "utils/raqam";
import ReactHTMLParser from "react-html-parser";
import { toNumber } from "lodash";

export interface ProblemProps {
  answer?: number;
  handleAnswerChange: (sa: number) => void;
}

const Problem: React.FC<ProblemProps> = ({ answer, handleAnswerChange }) => {
  const content = useRecoilValue(getCurrentContent);
  const currentProblem = useRecoilValue(getCurrentProblem);

  const transitions = useTrail(content.options.length, {
    config: { mass: 5, tension: 3000, friction: 300 },
    transform: "scale(1)",
    from: { transform: "scale(0)" },
  });

  return (
    <div className="w-full">
      <div>
        <p className="font-semibold text-lg text-gray-700 mb-2 dark:text-gray-200">
          {appStrings.question} {toPersian(currentProblem, {})}
        </p>
        <p className="text-center text-lg text-gray-900 dark:text-gray-100">
          {ReactHTMLParser(toPersian(content.body, {}))}
        </p>
      </div>

      <div className="flex flex-col space-y-4 mt-12 w-full md:w-8/12 mx-auto">
        {transitions.map((props, key) => (
          <animated.div key={key} style={props}>
            <p
              key={key}
              onClick={() => handleAnswerChange(content.options[key].id)}
              className={`${
                answer === content.options[key].id ||
                toNumber(content.options[key].id) ===
                  toNumber(content.userAnswer)
                  ? "bg-primary-500 text-white font-semibold"
                  : "bg-gray-200 text-gray-800 font-medium ring-0 dark:bg-gray-600 dark:text-gray-100"
              } text-right py-4 px-4 rounded-lg select-none cursor-pointer transition duration-150 hover:shadow-md`}
            >
              {ReactHTMLParser(toPersian(content.options[key].body, {}))}
            </p>
          </animated.div>
        ))}
      </div>
      {content.hint && (
        <div className=" rounded-3xl py-2 flex flex-row items-center mt-6 text-center">
          <img className="w-10 ml-6" src="/assets/img/info.png" alt="info" />
          <p className="text-gray-900 text-sm dark:text-gray-100">
            {ReactHTMLParser(toPersian(content.hint, {}))}
          </p>
        </div>
      )}
    </div>
  );
};

export default Problem;
